"use client";

import { useRef, type ReactNode, Suspense } from "react";
import {
  createModalHistoryStore,
  ModalHistoryContext,
  type ModalHistoryStore,
} from "./modal-history-store";
import { useModalHistorySync } from "./use-modal-history-sync";

/** Runs the sync effect inside the provider so it sees the same store. */
function ModalHistorySync(): null {
  useModalHistorySync();
  return null;
}

/**
 * Mount once, INSIDE `GlobalModalStackProvider`, above everything that opens
 * modals. Gives the tree a shared modal-history store and runs the Back/
 * Forward sync effect against it.
 */
export function HubModalHistoryProvider({
  children,
}: {
  children: ReactNode;
}) {
  const storeRef = useRef<ModalHistoryStore | null>(null);
  storeRef.current ??= createModalHistoryStore();

  return (
    <ModalHistoryContext.Provider value={storeRef.current}>
      {/* Reads URL data (usePathname/useSearchParams). Under `cacheComponents`
          that must sit inside a Suspense boundary or the page cannot prerender.
          It renders nothing, so the fallback is null. */}
      <Suspense fallback={null}>
        <ModalHistorySync />
      </Suspense>
      {children}
    </ModalHistoryContext.Provider>
  );
}
